import store from '@/store'
import defaultSettings from '@/settings'
import useSettingsStore from '@/store/modules/settings'
import { getToken } from '@/utils/auth'

/**
 * 动态修改标题
 */
export function useDynamicTitle() {
  const settingsStore = useSettingsStore();
  const hasToken = getToken();
  
  if (hasToken) {
    // 登录后显示完整标题
    if (settingsStore.dynamicTitle) {
      document.title = settingsStore.title + ' - ' + defaultSettings.title;
    } else {
      document.title = defaultSettings.title;
    }
  } else {
    // 未登录时显示简洁标题
    document.title = '甘肃省智能网联车辆测试示范应用服务系统';
  }
}